import SettingHeaderCard from 'components/cs/settings-header-card';
import React, { useState } from 'react';
import ResetPasswordModal from './reset-password';
import { ReactComponent as ShieldIcon } from 'assets/icons/shield.svg';

const Password = () => {
  const [openResetPassword, setOpenResetPassword] = useState(false);

  return (
    <div className='w-full'>
      <div className='space-y-12'>
        <SettingHeaderCard
          title='Manage Password'
          icon={<ShieldIcon />}
          details='Easily manage availability on the foodcourt App'
        />
        <div className='flex justify-between font-medium'>
          <div className='text-sm'>
            <h2>Current Password</h2>
            <p>*************</p>
          </div>
          <button
            onClick={() => setOpenResetPassword(true)}
            className='text-[#595959] text-xs border border-[#E8E8E8] shadow-sm rounded-[4px] p-1 w-[118px] h-[32px] '>
            Reset Password
          </button>
        </div>
        {openResetPassword && (
          <ResetPasswordModal show onClose={() => setOpenResetPassword(false)} />
        )}
      </div>
    </div>
  );
};

export default Password;
